// extracted by mini-css-extract-plugin
export var container = "_c4-1";
export var cornerButtonContainer = "_c4-6";
export var disabled = "_c4-2";
export var dragActive = "_c4-3";
export var fileContainer = "_c4-5";
export var hiddenInput = "_c4-4";
export var widthContainer = "_c4-0";